// @flow
import * as React from "react";
import idx from "idx";
import moment from "moment";
import Api from "../Tournaments/Api";
import { timer } from "../Timers";
import { calcBonusDuration } from "../DepositBonus";

export const useBonusTimerStorage = () => {
  const [showTimer, toggleTimer] = React.useState(() => {
    // проверяем, есть ли запись hideBonusTimer в sessionStorage;
    // если да, то по дефолту не показываем ничего,
    // потому что юзер уже спрятал напоминалку про бонус
    try {
      const timerView = sessionStorage.getItem("hideBonusTimer");
      if (timerView != null) {
        return false;
      }
    } catch (e) {
      console.warn("sessionStorage error");
    }

    return true;
  });

  React.useEffect(() => {
    try {
      if (showTimer === false) {
        sessionStorage.setItem("hideBonusTimer", "true");
      }
    } catch (e) {
      console.warn(`sessionStorage error`);
    }
  }, [showTimer]);

  return [showTimer, toggleTimer];
};

type ApiProps = {
  time: number
};

export const useBonusTimerApi = ({ time }: ApiProps) => {
  const api = React.useContext(Api);

  // componentWillUnmount
  React.useEffect(() => {
    return () => {
      api.clearEntities("/api/reg-bonus");
    };
  }, []);

  const features = idx(
    api.readEntity("/api/features/list"),
    features => features.value
  );
  if (
    !features ||
    !features.find(feature => feature.name === "first_deposit_bonus")
  ) {
    return null;
  }

  const bonus = idx(api.readEntity("/api/reg-bonus"), bonus => bonus.value);
  if (bonus == null) {
    return null;
  }

  const { expire_time, creation_time, percent, promo, status } = bonus;

  const currentTime = moment(time);
  const creationTime = moment.unix(creation_time);
  const expireTime = moment.unix(expire_time);

  const duration = moment
    .duration(expireTime.diff(currentTime))
    .asMilliseconds();

  if (duration < 0 || status !== "available") {
    return null;
  }

  const ticker = timer({ start: currentTime, end: expireTime });
  const progress = calcBonusDuration({
    currentTime,
    creationTime,
    expireTime
  });

  return {
    percent,
    promo,
    status,
    duration,
    progress,
    ticker,
    expire_time
  };
};



// WEBPACK FOOTER //
// ./src/components/hooks/useBonusTimer.js